{
  "LOGIN": {
    "TITLE": "Login to Chatwoot",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Prosím zadajte platnú e-mailovú adresu"
    },
    "PASSWORD": {
      "LABEL": "Password",
      "PLACEHOLDER": "Password"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login successful",
      "ERROR_MESSAGE": "Could not connect to Woot server. Please try again.",
      "UNAUTH": "Username or password is incorrect. Please try again."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Forgot your password?",
    "CREATE_NEW_ACCOUNT": "Create new account",
    "SUBMIT": "Prihlásenie",
    "SAML": {
      "LABEL": "Login via SSO",
      "TITLE": "Initiate Single Sign-on (SSO)",
      "SUBTITLE": "Enter your work email to access your organization",
      "BACK_TO_LOGIN": "Login via Password",
      "WORK_EMAIL": {
        "LABEL": "Work Email",
        "PLACEHOLDER": "Enter your work email"
      },
      "SUBMIT": "Continue with SSO",
      "API": {
        "ERROR_MESSAGE": "SSO authentication failed. Please check your credentials and try again."
      }
    }
  }
}
